module.exports = __webpack_public_path__ + "img/absolut-first-block-bg-mobile.816c8896.jpg";